import { InMemoryCache, defaultDataIdFromObject } from "@apollo/client/cache";

const TypePerson = "Person";
const Membership = "Membership";
const IndividualAllocation = "IndividualAllocation";
const Import = "Import";

const merge = (existing = [], incoming) => {
  return incoming;
};

const mergeTagMetadata = (existing, incoming) => {
  if (!incoming) {
    return existing;
  }
  return { ...existing, ...incoming };
};

// Different queries return different permission subsets; shallow-merge so one
// query does not wipe fields written by another (e.g. getPerson vs memberships).
const mergePermissions = (existing, incoming) => {
  if (!incoming) {
    return existing;
  }
  return { ...existing, ...incoming };
};

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // v4 equivalent of v3 cacheRedirects: resolves getPerson from the in-memory cache
        // when the entity was already loaded as part of a larger query (e.g. team members list),
        // avoiding a redundant network request. Returns undefined to fall back to network.
        getPerson: (_, { args, toReference, canRead }) => {
          if (!args?.aggregateId) return undefined;
          const ref = toReference({
            __typename: TypePerson,
            aggregateId: args.aggregateId,
          });
          return canRead(ref) ? ref : undefined;
        },
      },
    },
    Tag: {
      fields: {
        tagAttributesMetaData: {
          merge: mergeTagMetadata,
        },
      },
    },
    LinkedStrategy: {
      keyFields: false,
    },
    Group: {
      fields: {
        tags: {
          merge,
        },
        permissions: {
          merge: mergePermissions,
        },
      },
    },
    ObjectiveAttribute: {
      keyFields: false,
    },
    GroupAttribute: {
      keyFields: false,
    },
    // Permissions objects have no ID — embed them in their parent to avoid
    // merge conflicts when different queries return different permission subsets.
    GroupPermissions: {
      keyFields: false,
    },
    PersonPermissions: {
      keyFields: false,
    },
    Person: {
      fields: {
        memberOf: {
          merge,
        },
        memberships: {
          merge,
        },
        allocations: {
          merge,
        },
        tags: {
          merge,
        },
        accessGroups: {
          merge,
        },
        permissions: {
          merge: mergePermissions,
        },
      },
    },
  },
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case Import:
        return `${Import}:${object.id}-${object.created}`; // import ids may not be unique
      case TypePerson:
        return `${TypePerson}:${object.aggregateId}`;
      case IndividualAllocation:
        return `${IndividualAllocation}:${object.allocationId}`;
      case Membership:
        return `${Membership}:${object.currentCompositeId}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
});

export default cache;
